import React from 'react';
import il8n from 'i18next';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import Divider from '@material-ui/core/Divider';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Slide from '@material-ui/core/Slide';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function View(props) {
  const { presenter, open, selectedCountry, countries } = props;
  return (
    <Dialog
      fullScreen
      open={open}
      onClose={() => presenter?.onCloseClick()}
      scroll="paper"
      TransitionComponent={Transition}
    >
      <DialogTitle>{il8n.t('country.title')}</DialogTitle>
      <Divider />
      <DialogContent>
        <List>
          {selectedCountry && (
            <>
              <ListItem
                key={selectedCountry.name}
                button
                onClick={() => presenter.onCountrySelect(selectedCountry)}
              >
                <ListItemText
                  primary={`${selectedCountry.name} (${selectedCountry.phonePrefix})`}
                />
              </ListItem>
              <Divider component="li" />
            </>
          )}
          {countries?.map((country) => {
            return (
              <>
                <ListItem
                  key={country.name}
                  button
                  onClick={() => presenter.onCountrySelect(country)}
                >
                  <ListItemText primary={`${country.name} (${country.phonePrefix})`} />
                </ListItem>
                <Divider component="li" />
              </>
            );
          })}
        </List>
      </DialogContent>
    </Dialog>
  );
}
